<template>
  <div class="cart-dropdown-wrapper">
    <!-- Carrinho -->
    <b-nav-item
      id="shoppingCartIcon"
      class="dropdown-cart mr-25"
      @click="openCart"
    >
      <div class="cart-icon-container">
        <feather-icon
          class="cart-icon"
          icon="ShoppingCartIcon"
          size="18"
        />
        <span v-if="cartCount > 0" class="cart-badge">{{ cartCount > 99 ? '99+' : cartCount }}</span>
      </div>
      <b-tooltip target="shoppingCartIcon" triggers="hover" placement="bottom">
        Carrinho
      </b-tooltip>
    </b-nav-item>

    <!-- Rascunhos -->
    <b-nav-item
      v-if="rascunhoAtivo"
      id="draftIcon"
      class="dropdown-cart"
      @click="openDraftModal"
    >
      <div class="cart-icon-container">
        <feather-icon
          class="cart-icon"
          icon="FileTextIcon"
          size="18"
        />
        <span v-if="draftCount > 0" class="cart-badge">{{ draftCount > 99 ? '99+' : draftCount }}</span>
      </div>
      <b-tooltip target="draftIcon" triggers="hover" placement="bottom">
        Rascunhos
      </b-tooltip>
    </b-nav-item>

    <draft-orders-modal v-if="rascunhoAtivo" ref="draftModal" @drafts-loaded="onDraftsLoaded" />
  </div>
</template>

<script>
import { BNavItem, BTooltip } from 'bootstrap-vue';
import DraftOrdersModal from '@/components/modal/DraftOrdersModal.vue';
import SLS_pedidosVendasService from '@/services/Operacoes/sls_pedidoVendas.service';
import { mapGetters } from 'vuex';

export default {
  components: {
    BNavItem,
    BTooltip,
    DraftOrdersModal,
  },
  data() {
    return {
      draftCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      cartCount: 'PedidosStore/getTotalItensPedido',
    }),
    rascunhoAtivo() {
      // Menu de rascunhos: preferência ativa + perfil autorizado.
      return this.$store.getters['preferencias/rascunhoPermitido'];
    },
  },
  methods: {
    openCart() {
      this.$router.push({ name: 'app-carrinho-compra' });
    },
    openDraftModal() {
      this.$refs.draftModal.openModal();
    },
    onDraftsLoaded(count) {
      this.draftCount = count;
    },
    async loadDraftCount() {
      if (!this.rascunhoAtivo) {
        this.draftCount = 0;
        return;
      }
      try {
        const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
        const perfil = perfilLogado?.perfil_acesso_nome || 'Representante';

        let representanteId = null;
        if (perfil === 'Representante') {
          const representanteData = JSON.parse(localStorage.getItem('representanteData'));
          representanteId = representanteData?.representanteid;
        }

        const params = {};
        if (representanteId) {
          params.perfilTipo = perfil;
          params.perfilId = representanteId;
        }

        const slsPedidoVendasService = new SLS_pedidosVendasService();
        const result = await slsPedidoVendasService.getRascunhosPedidosVendas(params);

        const drafts = (result && (result.data || result)) || [];
        this.draftCount = Array.isArray(drafts) ? drafts.length : (drafts?.length || 0);
      } catch (error) {
        console.error('Erro ao carregar contagem de rascunhos:', error);
      }
    },
  },
  watch: {
    rascunhoAtivo(newValue) {
      if (newValue) {
        this.loadDraftCount();
      } else {
        this.draftCount = 0;
      }
    },
  },
  mounted() {
    this.$store.dispatch('preferencias/load').catch(() => {}).finally(() => {
      if (this.rascunhoAtivo) {
        this.loadDraftCount();
      }
    });

    this.$root.$on('draft:updated', () => {
      this.loadDraftCount();
    });

    this.$root.$on('draft:created', () => {
      this.loadDraftCount();
    });
  },
  beforeDestroy() {
    this.$root.$off('draft:updated');
    this.$root.$off('draft:created');
  },
};
</script>

<style lang="scss" scoped>
.cart-dropdown-wrapper {
  display: flex;
  align-items: center;
}

.dropdown-cart {
  list-style: none;

  a {
    display: flex;
    align-items: center;
    padding: 0;
  }
}

.cart-icon-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.cart-icon {
  color: var(--text-muted, #64748b);
  transition: color 0.15s;

  &:hover {
    color: var(--text-body, #1e293b);
  }
}

.cart-badge {
  position: absolute;
  top: -2px;
  right: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: var(--primary, #6366f1);
  color: #fff;
  border-radius: 8px;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1;
}

body.dark-layout {
  .cart-icon {
    color: var(--text-muted, #94a3b8);

    &:hover {
      color: var(--text-body, #e2e8f0);
    }
  }
}
</style>
